export const COLORS = {
  background: '#485c70', // The actual gradient code for this is defined in App.css (separately from here intentionally, to support maximum compatability)
  text: '#FFF',
  primaryHighlight: '#79B996',
  secondaryHighlight: '#79B996', //6A85A0
  header: 'white',
  white: '#FFF',  // Defined in the constant just in case we want to switch to a common off-white shade in the future 
  black: '#000',  // Defined in the constant just in case we want to switch to a common off-black shade in the future
  buttonHover: '',  // TODO
}
